import { marked } from 'marked';
import { isEmpty } from '@cutwise/utils';
export function formatMarkdown(text) {
    // if for some reason empty value is passed
    if (typeof text !== 'string') {
        return text;
    }
    // for empty string
    if (isEmpty(text)) {
        return text;
    }
    const renderer = {
        link(href, _, text) {
            return `<a target="_blank" href="${href}">${text}</a>`;
        },
    };
    marked.use({ renderer });
    const result = marked.parse(text);
    // remove blank line breaks in the end
    return result.trim();
}
